import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { listIncome } from './action';
import { IncomeReportTableConfig } from './IncomeReportTableConfig';

function IncomeReport() {
  useInjectReducer({ key: 'income', reducer });
  useInjectSaga({ key: 'income', saga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const incomeState = useSelector((state) => state.income || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = IncomeReportTableConfig(handleSearch, handleReset, authState.userResponsibilities);
    setColumns(columns);
    dispatch(listIncome({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listIncome(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listIncome({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listIncome({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card title="Income Reports">
        <Table
          columns={columns}
          loading={incomeState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={incomeState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={incomeState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={incomeState.loading}
          onChange={onPageChange}
        />
      </Card>
    </>
  );
}

export default IncomeReport;
